export function isExternalURL(url: string): boolean {
  return new URL(url, window.location.origin).origin !== window.location.origin;
}
